import React, { useContext, useEffect, useState } from "react";
import NubeSubirArchivo from "../../../assets/images/generico/NubeSubirArchivo";
import "./AdjuntaOrden.css";
import CruzImagenPrevia from "../../../assets/images/generico/CruzImagenPrevia";
import {
  resetOrdenEstudio,
  wsDeleteOrdenEstudio,
  wsPostSubirOrden,
} from "../../../context/Actions/ordenEstudio/ordenEstudio";
import { PortalContext } from "../../../context/Provider";
import { hideModal } from "../../../context/Actions/modal/modal";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { IonSpinner } from "@ionic/react";
import {
  limpiarListaMultimedia,
  resetSubidaOrdenLoadingFlg,
  subidaOrdenLoadingFlg,
  wsGetListaMultimediaPaciente,
  wsGetTurnosPacienteQr,
} from "../../../context/Actions/turnos/turnosPaciente";
import {
  resetOrdenLaboratorio,
  wsDeleteOrdenLaboratorio,
  wsPostSubirOrdenLaboratorio,
} from "../../../context/Actions/ordenLaboratorio/ordenLaboratorio";
import { GlobalContext } from "../../../../global/context/Provider";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";

const AdjuntaOrden = ({ idturno, idProtocolo, flg, dissmiss }) => {
  const {
    ordenEstudioDispatch,
    ordenEstudioState,
    modalDispatch,
    turnosPacienteDispatch,
    ordenLaboratorioDispatch,
    ordenLaboratorioState,
    turnosPacienteState,
    selectDropDownState,
  } = useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch } = useContext(GlobalContext);

  const [ordenEstudioDto, setOrdenEstudioDto] = useState([]);
  const [inputKey, setInputKey] = useState();
  const [flgActualiceOrden, setFlgActualiceOrden] = useState(null);

  const getBinario = (orden, extension) => {
    const isPng = "data:image/png;base64,";
    const isJpg = "data:image/jpg;base64,";
    const isJpeg = "data:image/jpeg;base64,";
    let binario = "";

    switch (extension) {
      case "png":
        binario = orden.replace(isPng, "");
        break;
      case "jpg":
        binario = orden.replace(isJpg, "");
        break;
      default:
        binario = orden.replace(isJpeg, "");
    }
    return binario;
  };

  //si el turno tiene ordenes en el ws, las cargo al array
  const [flgOrden, setFlgOrden] = useState(null);

  useEffect(() => {
    if (flgActualiceOrden) {
      if (ordenEstudioDto.length === 0) {
        setFlgOrden(true);
      }
    }
    //eslint-disable-next-line
  }, [ordenEstudioDto, flgActualiceOrden]);

  useEffect(() => {
    const familiarID = !selectDropDownState.selectDropDown.selectGlobal
      .pacienteElegido?.paciente?.codigo
      ? false
      : selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ?.paciente?.codigo;

    if (flgOrden === true) {
      wsGetTurnosPacienteQr()(turnosPacienteDispatch);
      setFlgOrden(false);
    }
    //eslint-disable-next-line
  }, [flgOrden]);

  const seleccionarImagen = (e) => {
    if (e.target.files[0].size > 5e6) {
      showToaster(
        {
          texto: "La imagen no puede superar los 5MB",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          if (ordenEstudioDto.length < 2) {
            setOrdenEstudioDto([
              ...ordenEstudioDto,
              {
                binario: getBinario(
                  reader.result,
                  e.target.files[0].type.replace("image/", "")
                ),
                idremoto:
                  idProtocolo !== 0 &&
                  idProtocolo !== undefined &&
                  idProtocolo !== null
                    ? idProtocolo
                    : idturno,
                tag: e.target.files[0].type.replace("image/", ""),
              },
            ]);
            setFlgActualiceOrden(true);
          }
        }
      };
      if (e.target.files[0]) {
        reader.readAsDataURL(e.target.files[0]);
      }
    }
  };

  const eliminarElemento = (elemento) => {
    setOrdenEstudioDto(
      ordenEstudioDto.filter((item) => item.binario !== elemento.binario)
    );

    if (
      idProtocolo !== 0 &&
      idProtocolo !== undefined &&
      idProtocolo !== null &&
      elemento.id
    ) {
      setFlgActualiceOrden(true);
      wsDeleteOrdenLaboratorio(
        idProtocolo,
        elemento.idRemoto
      )(ordenLaboratorioDispatch);
    } else if (elemento.id) {
      setFlgActualiceOrden(true);
      wsDeleteOrdenEstudio(idturno, elemento.idRemoto)(ordenEstudioDispatch);
    }

    //inputKey estoy usando para renderizar nuevamente el componente cuando elimino todas las imagenes
    if (inputKey) {
      setInputKey(false);
    } else {
      setInputKey(true);
    }
  };

  const subirOrden = () => {
    const ordenFiltrada = ordenEstudioDto.filter(
      (item) => item.id === null || item.id === undefined
    );
    if (
      idProtocolo !== 0 &&
      idProtocolo !== undefined &&
      idProtocolo !== null
    ) {
      wsPostSubirOrdenLaboratorio(ordenFiltrada)(ordenLaboratorioDispatch);
      subidaOrdenLoadingFlg()(turnosPacienteDispatch);
      limpiarListaMultimedia()(turnosPacienteDispatch);
    } else {
      wsPostSubirOrden(ordenFiltrada)(ordenEstudioDispatch);
      subidaOrdenLoadingFlg()(turnosPacienteDispatch);
      limpiarListaMultimedia()(turnosPacienteDispatch);
    }
    localStorage.setItem("alertaActive", false);
  };

  useEffect(() => {
    if (idProtocolo > 0) {
      wsGetListaMultimediaPaciente(
        false,
        idProtocolo,
        false
      )(turnosPacienteDispatch);
      // setFlgActualiceOrden(true);
    } else {
      wsGetListaMultimediaPaciente(
        idturno,
        false,
        false
      )(turnosPacienteDispatch);
      // setFlgActualiceOrden(true);
    }
  }, [ordenEstudioState.ordenEstudio.data]);

  // useEffect(() => {
  //   if (flgActualiceOrden) {
  //     LimpiarSelectProximoTurno()(selectDropDownDispatch);
  //     setFlgActualiceOrden(false);
  //   }
  // }, [flgActualiceOrden]);

  useEffect(() => {
    if (
      (ordenEstudioState.ordenEstudio.error !== null &&
        ordenEstudioState.ordenEstudio.error !== false) ||
      (ordenLaboratorioState.ordenLaboratorio.error !== null &&
        ordenLaboratorioState.ordenLaboratorio.error !== false)
    ) {
      showToaster(
        {
          texto: ordenEstudioState.ordenEstudio.error
            ? ordenEstudioState.ordenEstudio.error.detail
            : ordenLaboratorioState.ordenLaboratorio.error.detail,
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      resetOrdenLaboratorio()(ordenLaboratorioDispatch);
      resetOrdenEstudio()(ordenEstudioDispatch);
      resetSubidaOrdenLoadingFlg()(turnosPacienteDispatch);
    }
    //eslint-disable-next-line
  }, [
    ordenEstudioState.ordenEstudio.error,
    ordenLaboratorioState.ordenLaboratorio.error,
  ]);

  //toasterOrden
  useEffect(() => {
    const familiarID = !selectDropDownState.selectDropDown.selectGlobal
      .pacienteElegido?.paciente?.codigo
      ? false
      : selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ?.paciente?.codigo;

    if (
      ordenEstudioState.ordenEstudio.data === "" ||
      ordenLaboratorioState.ordenLaboratorio.data === ""
    ) {
      showToaster(
        {
          texto: "Orden guardada exitosamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      resetOrdenLaboratorio()(ordenLaboratorioDispatch);
      resetOrdenEstudio()(ordenEstudioDispatch);
      limpiarListaMultimedia()(turnosPacienteDispatch);
      wsGetTurnosPacienteQr()(turnosPacienteDispatch);
      hideModal()(modalDispatch);
    }
    //eslint-disable-next-line
  }, [
    ordenEstudioState.ordenEstudio.data,
    ordenLaboratorioState.ordenLaboratorio.data,
  ]);

  useEffect(() => {
    if (
      ordenEstudioState.ordenEstudio.eliminado === "" ||
      ordenLaboratorioState.ordenLaboratorio.eliminado === ""
    ) {
      showToaster(
        {
          texto: "Orden eliminada exitosamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      resetOrdenEstudio()(ordenEstudioDispatch);
      resetOrdenLaboratorio()(ordenLaboratorioDispatch);
    }
    //eslint-disable-next-line
  }, [
    ordenEstudioState.ordenEstudio.eliminado,
    ordenLaboratorioState.ordenLaboratorio.eliminado,
  ]);

  let multimediaData = turnosPacienteState.turnosPaciente.listaMultimedia;

  //si el turno tiene ordenes en el ws, las cargo al array
  useEffect(() => {
    if (multimediaData) {
      if (multimediaData.length > 0) setOrdenEstudioDto(multimediaData);
    }
    //eslint-disable-next-line
  }, [multimediaData]);

  return (
    <React.Fragment>
      <Loading
        dataLoading={turnosPacienteState.turnosPaciente.loading}
        color="c-white"
        descripcion={
          turnosPacienteState.turnosPaciente.loading && "Cargando órdenes..."
        }
      />
      <div className="ptur-subirOrdenMedica-title-container bgcG-latex30">
        <span className="ptur-subirOrdenMedica-title c-white rb18l">
          Subir orden médica (frente y dorso)
        </span>
      </div>
      <div className="ptur-subirOrdenMedica-body bgc-white">
        <div className="ptur-subirOrdenMedica-texto">
          <span className="c-latex10 rb18l">
            Por favor adjunte la orden subiendo el
            <span className="rb18b"> frente y dorso. </span>
            Recuerde incluir su nombre completo, firma y DNI en el dorso. Si no
            la tiene en este momento, la puede subir luego desde{" "}
            <span className="rb18b">“Próximos turnos”.</span>
          </span>
        </div>
        <div className="ptur-subirOrdenMedica-seleccionarImagen bgc-latex95">
          <div className="ptur-subirOrdenMedica-vistaPrevia-container">
            {ordenEstudioDto.map((item, index) => (
              <div
                className="ptur-subirOrdenMedica-vistaPreviaConCruz"
                key={index}
              >
                <div
                  className="ptur-cruzImagenPrevia"
                  onClick={() => eliminarElemento(item)}
                >
                  <CruzImagenPrevia />
                </div>
                <img
                  src={`data:image/${item.tag};base64,${item.binario}`}
                  alt=""
                  className="ptur-subirOrdenMedica-vistaPrevia"
                />
              </div>
            ))}
          </div>

          <input
            type="file"
            name="image-upload"
            id="input"
            accept="image/*"
            onChange={seleccionarImagen}
            className="ptur-subirOrdenMedica-input"
            key={inputKey}
            autoComplete="off"
          />
          <div className="ptur-subirOrdenMedica-label-container">
            <label htmlFor="input" className="image-upload">
              <div className="ptur-subirOrdenMedica-botonSubir" htmlFor="input">
                <NubeSubirArchivo />
                <span className="ptur-subirOrdenMedica-textoSubir c-latex10 rb18m noSeleccionable">
                  Seleccionar imágenes aquí
                </span>
              </div>
            </label>
          </div>
        </div>

        <div className="ptur-subirOrdenMedica-botones">
          <button
            className={`ptur-subirOrdenMedica-btn rb16m c-white ${
              ordenEstudioDto.length <= 0 ||
              ordenEstudioState.ordenEstudio.loading ||
              ordenLaboratorioState.ordenLaboratorio.loading
                ? "bgc-grey65"
                : "bgc-latex30"
            }`}
            onClick={ordenEstudioDto.length > 0 ? subirOrden : () => {}}
            disabled={
              ordenEstudioDto.length <= 0 ||
              ordenEstudioState.ordenEstudio.loading ||
              ordenLaboratorioState.ordenLaboratorio.loading
            }
          >
            {ordenEstudioState.ordenEstudio.loading ||
            ordenLaboratorioState.ordenLaboratorio.loading ? (
              <IonSpinner />
            ) : (
              "Subir las imágenes"
            )}
          </button>
          {flg ? (
            <button
              className=" ptur-subirOrdenMedica-btn-outline bgc-white c-latex30 rb16m"
              disabled={
                ordenEstudioState.ordenEstudio.loading ||
                ordenLaboratorioState.ordenLaboratorio.loading
              }
              onClick={dissmiss}
            >
              Subir más tarde
            </button>
          ) : (
            <button
              className="ptur-subirOrdenMedica-btn-outline bgc-white rb16m c-latex30"
              onClick={dissmiss}
            >
              Cerrar
            </button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdjuntaOrden;
